import { render, staticRenderFns } from "./studentList.vue?vue&type=template&id=c854e108&scoped=true&"
import script from "./studentList.js?vue&type=script&lang=js&"
export * from "./studentList.js?vue&type=script&lang=js&"
import style0 from "./studentList.vue?vue&type=style&index=0&id=c854e108&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c854e108",
  null
  
)

export default component.exports